// extracted by css-extract-rspack-plugin
export default {"root":"Title-module__root___AhXKT"};